module.exports = __webpack_public_path__ + "static/media/10_blanco.c1ee168e.svg";